// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-page-icon[data-v-4887ebe9] {\n\tcolor: currentColor !important;\n}\n", ""]);
// Exports
module.exports = exports;
